import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=51aa4e08"
import script from "./Teams.vue?vue&type=script&lang=ts"
export * from "./Teams.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports